import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Form, Spinner } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import IconButton from 'components/common/IconButton';

const DetailsFacturesHeader = ({
  creerFacture,
  Timbre,
  setTimbre,
  isProcessing,
  nombreArticles,
  typeTransaction,
}) => {
  const creerlignesFacture = () => {
    creerFacture();
  };
  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Détails Transactions</h6>
        </Col>
        <Col xs="auto">
          <AdvanceTableSearchBox className="input-search-width" placeholder="Rechercher" />
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div
          className="bg-300 mx-3 d-none d-lg-block d-xl-none"
          style={{ width: '1px', height: '29px' }}
        ></div>
        <div className="d-flex align-items-center justify-content-end">
          <Form.Control
            type="number"
            value={Timbre}
            onChange={e => setTimbre(e.target.value)}
            className="me-2 w-25"
            step="0.001"
            min="0"
            disabled
          />

          <IconButton
            variant="falcon-default"
            size="sm"
            icon="caret-right"
            transform="shrink-3"
            className="mx-2 d-flex align-items-center"
            onClick={creerlignesFacture}
            disabled={isProcessing || nombreArticles === 0}
          >
            {isProcessing && (
              <Spinner animation="border" variant="primary" size="sm" className="me-2" />
            )}
            <span className="d-inline-block">
              {' '}
              Générer {typeTransaction === 'Retour' ? 'Retour' : 'Facture'}
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};

DetailsFacturesHeader.propTypes = {
  creerFacture: PropTypes.func.isRequired,
};

export default DetailsFacturesHeader;
